import { render, staticRenderFns } from "./UpgradePlanDialog.vue?vue&type=template&id=83f08aa2"
import script from "./UpgradePlanDialog.vue?vue&type=script&lang=js"
export * from "./UpgradePlanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports